import { Button, Card, Link, Typography } from '@mui/material'
import React from 'react'
import './price.scss'
import ArrowPrice from './ArrowPrice'
import Cube1 from './Cube-1';
import Cube2 from './Cube-2';
import ShurP from './ShurP';
import StarsP from './StarsP';
import {motion} from 'framer-motion'

const cardAnimation = {
    hidden: {
        x: -100,
        opacity: 0,
    },
    visible: custom => ({
        x: 0,
        opacity: 1,
        transition: { delay: custom * 0.2},
    }),
}

export default function Price() {
  return (
    <div className="price">
        <div className="price__container">
            <div className="price__left p-l">
                <div className="p-l__title">
                    <span></span>
                    <Typography variant='h2'>Цена</Typography>
                </div>
                <p>
                    Ознакомьтесь с нашими предложениями и подберите 
                    подходящий вам тариф. Если возникнут вопросы,<b> </b> 
                    <Link target="_blank" href='https://t.me/arturcronberg'>напишите нам</Link>.
                </p>
            </div>
            <motion.div initial="hidden" whileInView="visible" viewport={{amount: 0.4, once: true }} className="price__right p-r">
                <motion.div variants={cardAnimation} custom={2} whileHover={{scale: 1.1}} className="p-r__card-1 c-1">
                    <div className="c-1__content">
                        <span>Триал</span>
                        <div className="c-1__title">
                            <Typography variant='h3'>
                            0 ₽ 
                            </Typography>
                            <p>В месяц</p>
                        </div>
                        <div className="c-1__ben">
                            <li>
                                <ArrowPrice />
                                <p>действует 7 дней</p>
                            </li>
                            <li>
                                <ArrowPrice />
                                <p>позволяет бесплатно проверить работу сервиса</p>
                            </li>
                        </div>
                    </div>
                    <div className="c-1__button-wrapper">
                        <a href='https://panel.clickanti.ru/reg'>
                            <Button variant='contained' className='c-1__button'>Попробовать</Button>
                        </a>
                    </div>
                </motion.div>
                <motion.div variants={cardAnimation} custom={2} whileHover={{scale: 1.1}} className="p-r__card-1 c-1">
                    <div className="c-1__content">
                        <span>Стандартный</span>
                        <div className="c-1__title">
                            <Typography variant='h3'>
                            от 2 900 ₽ 
                            </Typography>
                            <p>В месяц</p>
                        </div>
                        <div className="c-1__ben">
                            <li>
                                <ArrowPrice />
                                <p>В зависимости от количества визитов на ваш сайт</p>
                            </li>
                        </div>
                    </div>
                    <div className="c-1__button-wrapper">
                        <a href='https://panel.clickanti.ru/reg'>
                            <Button variant='contained' className='c-1__button'>Купить</Button>
                        </a>
                    </div>
                </motion.div>
            </motion.div>
        </div>
    </div>
  )
}